import { z } from 'zod';
import { ModuleManifest } from '@momentum/shared';

export const MOMENTUM_BOARD_ID = 'momentum-board';
export const BOARD_HOP_MS = 750;
export const BOARD_ROLL_MS = 900;
export const momentumBoardManifest = ModuleManifest.parse({
  id: MOMENTUM_BOARD_ID, version: '0.1.0', name: 'Momentum board section',
  description: 'A playable ceramic board section: roll, hop and choose between bridge and crystal routes.',
  disposable: false, players: { min: 2, max: 6 }, participation: 'individual', teams: null,
  voice: { scope: 'shared' },
  capabilities: { launchesChildren: false, childModuleIds: [], usesRandom: true, hasPrivateData: false, renderer: 'board' },
  launchableFromLobby: true,
});
export const MomentumBoardConfig = z.object({});
export type MomentumBoardConfig = z.infer<typeof MomentumBoardConfig>;
export const MomentumBoardAction = z.discriminatedUnion('type', [
  z.object({ type: z.literal('roll'), turnId: z.string() }).strict(),
  z.object({ type: z.literal('route'), turnId: z.string(), rollId: z.string(), from: z.string(), to: z.string() }).strict(),
]);
export type MomentumBoardAction = z.infer<typeof MomentumBoardAction>;
